import React from 'react';
import { abgGraphqlClient, ProxyGraphClients } from '@atlassian/temp-client-utils';
import { generatedTypesNew } from '@css-xp/graphtypes';
import { usePersistedCacheQuery } from '@css-xp/ppc-custom-hooks';
import { fetchLinkedEntitlementsPPC } from '../queries/fetch-linked-entitlements-ppc';

interface UseFetchLinkedEntitlementsPPCQueryVariables {
  transactionAccountId?: string | null;
  entitlementId: string;
  containerId?: string;
  currentEntitlementType?: generatedTypesNew.LinkedEntitlementTypes;
  destinationEntitlementType: Array<generatedTypesNew.LinkedEntitlementTypes>;
  productType: generatedTypesNew.LinkedProductTypes;
  findProducts?: boolean;
  findApps?: boolean;
  skipOption?: boolean;
  query?: typeof fetchLinkedEntitlementsPPC;
}

export const useFetchLinkedEntitlementsPPCQuery = ({
  entitlementId,
  containerId,
  currentEntitlementType,
  destinationEntitlementType,
  productType,
  findProducts,
  findApps,
  transactionAccountId,
  skipOption = false,
  query = fetchLinkedEntitlementsPPC,
}: UseFetchLinkedEntitlementsPPCQueryVariables) => {
  const ansClient = React.useMemo(() => abgGraphqlClient(ProxyGraphClients.ANS), []);
  return usePersistedCacheQuery<
    generatedTypesNew.FetchLinkedEntitlementsPpcQuery,
    generatedTypesNew.FetchLinkedEntitlementsPpcQueryVariables
  >(query, {
    variables: {
      id: entitlementId,
      searchLinkedEntitlementParams: {
        entitlementId,
        containerId: containerId ?? null,
        currentEntitlementType,
        destinationEntitlementType,
        productType,
        findProducts,
        findApps,
      },
      transactionAccountId,
    },
    skip: skipOption,
    client: ansClient,
  });
};
